import React from 'react';
import { AlertTriangle } from 'lucide-react';

const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-MY', {
    style: 'currency',
    currency: 'MYR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount).replace('MYR', 'RM');
};

export const AllocationBanner = ({ remainingAllocation }) => {
  return (
    <div className="relative overflow-hidden rounded-xl bg-gradient-to-r from-primary/10 via-primary/5 to-primary/10 border border-primary/20 p-6">
      {/* Background decoration */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_50%,hsl(var(--primary)/0.1),transparent_50%)]" />
      
      <div className="relative flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0 h-12 w-12 rounded-full bg-primary/10 flex items-center justify-center">
            <AlertTriangle className="h-6 w-6 text-primary" />
          </div>
          <div>
            <h3 className="font-display font-bold text-lg text-foreground mb-1">
              Pre-Series A Allocation Nearly Full
            </h3>
            <p className="text-muted-foreground text-sm">
              Remaining slots are limited. Submit your pledge before the round closes.
            </p>
          </div>
        </div>
        
        <div className="flex-shrink-0 text-right">
          <p className="text-xs text-muted-foreground mb-1">Remaining Allocation</p>
          <p className="text-2xl font-display font-bold text-primary">
            {formatCurrency(remainingAllocation)}
          </p>
        </div>
      </div>
    </div>
  );
};

export default AllocationBanner;
